<template>
  <!-- 校本抢课分组选课 -->
  <div class="choseCourse clearfix">
    <div class="fl" v-if="list">
      <van-sidebar v-model="activeKey">
        <van-sidebar-item
          v-for="item in list.Results"
          :key="item.SubjectGroupID"
          :title="item.SubjectGroupName"
        ></van-sidebar-item>
      </van-sidebar>
    </div>
    <div
      class="content fr"
      style="margin-bottom: 100px;"
      v-if="list&&list.Results[activeKey].Childrens.length>0 && list.Results[activeKey].Childrens!==undefined"
    >
      <div class="content-header">
        <p>
          本次最少选
          <span>{{list.MinOptionalCourse}}</span>点，最多选
          <span>{{list.MaxOptionalCourse}}</span>点，已选
          <span>{{list.SelfSelectCount}}</span>
        </p>
      </div>
      <div class="content-header">
        <p>{{list.Results[activeKey].SubjectGroupName}}</p>
        <p>
          本组最少选
          <span>{{list.Results[activeKey].MinSubjectNum}}</span>点，最多选
          <span>{{list.Results[activeKey].MaxSubjectNum}}</span>点，已选
          <span>{{list.Results[activeKey].SelectNum}}</span>点
        </p>
      </div>
      <div v-for="(item1,j) in list.Results[activeKey].Childrens" :key="item1.SubjectGroupID">
        <div class="content-main">
          <p style="padding-top:25px;">{{item1.SubjectGroupName}}</p>
          <p style="padding-top:10px;">
            本组最少选
            <span>{{item1.MinSubjectNum}}</span>点，最多选
            <span>{{item1.MaxSubjectNum}}</span>点，已选
            <span>{{item1.SelectNum}}</span>点
          </p>
          <div
            class="course"
            v-for="item2 in list.Results[activeKey].Childrens[j].Courses"
            :key="item2.AID"
          >
            <div>
              <span style="display:block">{{item2.SubjectName}}</span>
              <!-- <img :src="igmUrl" alt /> -->
              <p class="teacher">教师名称：{{item2.TeacherName?item2.TeacherName:'无'}}</p>
              <p class="cours">上课时间：{{item2.TimesInfo}}</p>
              <p class="current">当前已选：{{item2.SelectCount}}/{{item2.StudentLimitation}}人</p>
              <p class="diot">点数{{item2.SubjectScore}}点</p>
              <div class="op-btn">
                <!-- <div class="introduce-btn" v-if="item2.IsExistsCourseIntroduction" @click="lntroduce(item2)">课程介绍</div> -->
                <div>
                  <div class="btn" v-if="!item2.IsSelected" @click="chose(item2)">选择</div>
                  <div class="btn2" v-if="item2.IsSelected" @click="chose(item2)">已选</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content fr"
      style="margin-bottom: 100px;" v-if="list&&list.Results[activeKey].Childrens.length === 0">
      <div class="content-header">
        <p>
          本次最少选
          <span>{{list.MinOptionalCourse}}</span>点，最多选
          <span>{{list.MaxOptionalCourse}}</span>点，已选
          <span>{{list.SelfSelectCount}}</span>
        </p>
      </div>
      <div>
        <p style="line-height: 50px;text-align: center;">{{list.Results[activeKey].SubjectGroupName}}</p>
        <div class="content-main" >
          <p>
            本组最少选
            <span>{{list.Results[activeKey].MinSubjectNum}}</span>点，最多选
            <span>{{list.Results[activeKey].MaxSubjectNum}}</span>点，已选
            <span>{{list.Results[activeKey].SelectNum}}</span>点
          </p>
          <div class="course" v-for="item1 in list.Results[activeKey].Courses" :key="item1.SubjectGroupID">
            <div>
              <span style="display:block">{{item1.SubjectName}}</span>
              <!-- <img :src="igmUrl" alt /> -->
              <p class="teacher">教师名称：{{item1.TeacherName?item1.TeacherName:'无'}}</p>
              <p class="cours">上课时间：{{item1.TimesInfo}}</p>
              <p class="current">当前已选：{{item1.SelectCount}}/{{item1.StudentLimitation}}人</p>
              <p class="diot">点数{{item1.SubjectScore}}点</p>
              <div class="op-btn" >
                <!-- <div class="introduce-btn" v-if="item1.IsExistsCourseIntroduction" @click="lntroduce(item1)">课程介绍</div> -->
                <div>
                  <div class="btn" v-if="!item1.IsSelected" @click="chose(item1)">选择</div>
                  <div class="btn2" v-if="item1.IsSelected" @click="chose(item1)">已选</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <SingleBottomBtn @clickBtn="complete">完成</SingleBottomBtn>
  </div>
</template>
<script>
import { Notify } from "vant";
const courseUrl = require("@/assets/csmsTimeTable/onlineCourseSelection/course-class-img.png");
import SingleBottomBtn from "@/components/SingleBottomBtn";
export default {
  components: {
    SingleBottomBtn
  },
  data() {
    return {
      igmUrl: courseUrl,
      activeKey: 0,
      list: {},
      accountID: 0,
      ticket: '',
      classTableID:0,
    };
  },
  created() {
    this.classTableID=this.$store.state.csmstimetable.online.ClassTableID
    this.collectionID=this.$store.state.csmstimetable.online.CollectionID
    this.getSubjec('fir');
  },
  methods: {
    async getSubjec(type) {
      if(type === 'fir'){
        this.xy.loading()
      }
      let res = await this.xyapi.get(
        this.$store.state.apiPath +
          "/api/StudentOnLineSelectCourse/GetSchoolBasedGrabOnLineList",
        {
          classTableID: this.classTableID,
          isShow: false,
          studentID: 0
        }
      );
      if (res.success) {
        if (res.data) {
          this.list = res.data;
          if(this.activeKey >= this.list.Results.length){
            this.activeKey = this.list.Results.length -1;
          }
          this.accountID = res.data.AccountID
        }
      }
      this.xy.unloading()
    },
    async lntroduce (item) {
       this.$router.push({
         name:'choseCourseSchoolLntroduce',
         query:{
           classTableID:this.classTableID,
           introduce:item
         }
       });
    },
    async chose(i) {
      if (i.IsChoice) {
        if (!i.IsSelected) {//选中
          this.xy.loading()
          let res1 = await this.xyapi.get(`${this.xyMApi}/generate/api/Generate/Generate`, {
            accountID: this.accountID,
            classTableID: this.classTableID,
            aid: i.SelectCourseAID,
            studentID: i.SubjectID,
            studentOrganizationID: i.StudentOrganizationID
          })
          if (res1.success) {
            this.ticket = res1.data
            let res = await this.xyapi.post(
            this.$store.state.apiPath +"/api/StudentOnLineSelectCourse/SchoolBasedGrabSelect",{
              ClassTableID: this.classTableID,
              AID: i.AID,
              CoursePlanID: i.CoursePlanID,
              Type: i.Type,
              SelectAID: i.SelectiveAID,
              // SelectiveCourse: i.SelectiveCourse,
              SelectType: i.SelectiveType,
              StudentID: i.SubjectID,
              ticket: this.ticket
            });
            if (res.success) {
              this.getSubjec();
            } else {
              // 选择失败后释放名额
              let resRemove = await this.xyapi.get(`${this.xyMApi}/generate/api/Generate/Remove`, {
                accountID: this.accountID,
                classTableID: this.classTableID,
                aid: i.SelectCourseAID,
                studentID: i.SubjectID,
                studentOrganizationID: i.StudentOrganizationID
              })
              if (resRemove.success) {
                //
              }
              this.xy.unloading()
            }
          }else{
            this.xy.unloading()
          }
        } else {//取消选中
          this.xy.loading()
          let res1 = await this.xyapi.get(`${this.xyMApi}/generate/api/Generate/Remove`, {
            accountID: this.accountID,
            classTableID: this.classTableID,
            aid: i.SelectCourseAID,
            studentID: i.SubjectID,
            studentOrganizationID: i.StudentOrganizationID
          })
          if (res1.success) {
            this.ticket = res1.data
            let res = await this.xyapi.post(
            this.$store.state.apiPath + "/api/StudentOnLineSelectCourse/SchoolBasedGrabUnSelect",{
              ClassTableID: this.classTableID,
              AID: i.AID,
              CoursePlanID: i.CoursePlanID,
              Type: i.Type,
              SelectAID: i.SelectiveAID,
              // SelectiveCourse: i.SelectiveCourse,
              SelectType: i.SelectiveType,
              StudentID: i.SubjectID,
              ticket: this.ticket
            });
            if (res.success) {
              this.getSubjec();
            }else{
              this.xy.unloading()
            }
          }else{
            this.xy.unloading()
          }
        }
      }
    },
    async complete() {
      let _this = this;
      if (this.list.SelfSelectCount > this.list.MaxOptionalCourse) {
        Notify({
          type: "danger",
          message: "最多选择" + this.list.MaxOptionalCourse + "点"
        });
        return false;
      }
      if (this.list.SelfSelectCount < this.list.MinOptionalCourse) {
        Notify({
          type: "danger",
          message: "请至少选择" + this.list.MinOptionalCourse + "点"
        });
        return false;
      }
      for (var i = 0; i < this.list.Results.length; i++) {
        if (
          _this.list.Results[i].SelectNum > _this.list.Results[i].MaxSubjectNum
        ) {
          Notify({
            type: "danger",
            message:
              _this.list.Results[i].SubjectGroupName +
              "最多选择" +
              _this.list.Results[i].MaxSubjectNum +
              "点"
          });
          return false;
        }
        if (
          _this.list.Results[i].SelectNum < _this.list.Results[i].MinSubjectNum
        ) {
          Notify({
            type: "danger",
            message:
              _this.list.Results[i].SubjectGroupName +
              "请至少选择" +
              _this.list.Results[i].MinSubjectNum +
              "点"
          });
          return false;
        }
      }
      let res = await this.xyapi.post(
        this.$store.state.apiPath +
          "/api/StudentOnLineSelectCourse/SchoolBasedGrabCompleteSelectCourse",
        {
          ClassTableID: this.classTableID,
          StudentID: 0,
          CollectionID: this.collectionID
        }
      );
      if (res.success) {
        this.$router.push(`/home/onlineChoseClass`);
      }
    }
  }
};
</script>
<style lang="less" scoped>
.choseCourse {
  width: 100%;
  .van-sidebar-item--select {
    color: #323233;
    font-weight: 500;
    border-color: #4196ff;
  }
  .van-sidebar-item {
    border-bottom: 1px solid #e6e6e6;
    line-height: inherit;
  }
  .fl {
    width: 20%;
    margin-bottom: 110px;
    background: rgba(249, 249, 249, 1);
    box-shadow: 0px 4px 8px 0px rgba(151, 151, 151, 0.2);
  }
  .fr {
    width: 78%;
    margin: 10px auto;
  }
  .content>div:last-child{
    margin-bottom: 120px;
  }
  .content {
    background-color: #fff;
    .content-header {
      padding: 15px 0 20px 20px;
      height: 100px;
      width: 100%;
      background-image: url("./../../../../assets/csmsTimeTable/onlineCourseSelection/conheader.png");
      background-size: cover;
      line-height: 35px;
      p:nth-child(1) {
        font-size: 26px;
        color: rgba(51, 51, 51, 1);
      }
      p:nth-child(2) {
        font-size: 22px;
        color: rgba(153, 153, 153, 1);
      }
      p {
        span {
          color: #545efa;
          font-weight: bold;
        }
      }
    }
    .op-btn{
      display: flex;
      justify-content: flex-end;
      align-items: center;
      margin: 8px 0;
      .introduce-btn{
        background: #4196ff;
        padding: 0 10px;
        height: 52px;
        border-radius: 26px;
        line-height: 52px;
        text-align: center;
        font-weight: normal;
        font-size: 24px;
        font-weight: 400;
        color: #fff;
      }
      .btn-disabled{
        background: #dddd;
      }
    }
    .content-main {
      text-align: center;
      margin-top: 15px;
      p:nth-child(1) {
        font-size: 28px;
        color: #1d2157;
        font-weight: bold;
      }
      p:nth-child(2) {
        font-size: 22px;
        color: rgba(153, 153, 153, 1);
        line-height: 35px;
      }
      p {
        span {
          color: #545efa;
          font-weight: bold;
        }
      }
      // .course:last-child{
      //   margin-bottom: 120px;
      // }
      .course {
        padding: 25px 30px 0 30px;
        border-top: 1px solid #e6e6e6;
        border-bottom: 1px solid #e6e6e6;
        text-align: left;
        div {
          position: relative;
          // height: 250px;
          // span {
          //   float: left;
          // }
          img {
            position: absolute;
            width: 58px;
            height: 64px;
            left: 0;
            top: 25%;
          }
          .teacher {
            // position: absolute;
            // left: 20%;
            // top: 18%;
            font-size: 22px;
            text-align: left;
            font-weight: normal;
            color: #999999;
            margin: 5px 0;
          }
          .cours {
            // position: absolute;
            // left: 20%;
            // top: 38%;
            font-size: 22px;
            text-align: left;
            font-weight: normal;
            color: #999999;
            margin: 5px 0;
          }
          .current {
            // position: absolute;
            // left: 20%;
            // top: 58%;
            font-size: 22px;
            text-align: left;
            font-weight: normal;
            color: #999999;
            margin: 5px 0;
          }
          .diot {
            // position: absolute;
            // left: 20%;
            // top: 78%;
            font-size: 22px;
            text-align: left;
            font-weight: normal;
            color: #999999;
            margin: 5px 0;
          }
          .btn {
            // position: absolute;
            // right: 5%;
            // top: 25%;
            width: 124px;
            height: 52px;
            border: 1px solid rgba(255, 149, 0, 1);
            box-shadow: 0px 4px 8px 0px rgba(228, 111, 86, 0.5);
            border-radius: 26px;
            line-height: 52px;
            text-align: center;
            font-weight: normal;
            font-size: 24px;
            font-weight: 400;
            color: rgba(246, 141, 5, 1);
          }
          .btn2 {
            // position: absolute;
            // right: 5%;
            // top: 25%;
            width: 124px;
            height: 52px;
            background: rgba(255, 149, 0, 1);
            box-shadow: 0px 4px 8px 0px rgba(228, 111, 86, 0.5);
            border-radius: 26px;
            line-height: 52px;
            text-align: center;
            font-weight: normal;
            font-size: 24px;
            font-weight: 400;
            color: #ffffff;
          }
        }
      }
    }
  }
}
</style>